export default "__VITE_PUBLIC_ASSET__a785875d__"